module.exports = __webpack_public_path__ + "static/media/mastercard-logo.8881f32f.svg";